/**
 * Module dependencies.
 */

import { useMemo } from 'react';

/**
 * Export `useResolveCatalog` hook.
 */

export function useResolveCatalog(
  catalogCategories: any[],
  paths: string[],
): {
  category: any;
  product: any;
  subCategory: any;
} {
  const { category, product, subCategory } = useMemo(() => {
    let category;
    let subCategory;
    let product;

    if (paths?.[0]) {
      const id = paths[0].split('-')[0];

      category = catalogCategories.find((cat) => cat.id === id);
    }

    if (!!category && paths?.[1]) {
      const id = paths[1].split('-')[0];

      subCategory = category.subCategories.find((subCategory) => {
        return subCategory.id === id;
      });
    }

    if (!!subCategory && paths?.[2]) {
      const id = paths[2].split('-')[0];

      product = subCategory.products.find((product) => {
        return product.id === id;
      });
    }

    return {
      category,
      product,
      subCategory,
    };
  }, [catalogCategories, paths]);

  return { category, product, subCategory };
}
